require('./ctxDropdown.style.scss');

class CtxDropdownController {
    constructor() {

    }
}

class ctxDropdownDirective {
    constructor($timeout) {
        this.restrict = 'E';
        this.transclude = true;
        this.controller = CtxDropdownController;
        this.controllerAs = 'ctxDropdown';
        this.template = require('./ctxDropdown.template.html');
        this.bindToController = {
            dropdownId: '@',
            showPopup: '<?',
            onOpen: '&?',
            onClose: '&?'
        };
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ctxDropdown) {
        if (!ctxDropdown) return;
        if (ctxDropdown.dropdownId && ctxDropdown.onOpen) {
            element.on('show.bs.dropdown', () => {
                ctxDropdown.onOpen();
            });
        }
        if (ctxDropdown.dropdownId && ctxDropdown.onClose) {
            element.on('hide.bs.dropdown', () => {
                ctxDropdown.onClose();
            });
        }
    }

    static directiveFactory($timeout) {
        return new ctxDropdownDirective($timeout);
    }
}

ctxDropdownDirective.directiveFactory.$inject = ['$timeout'];

module.exports = ctxDropdownDirective.directiveFactory;



// WEBPACK FOOTER //
// ./src/shared/ctxDropdown/ctxDropdown.directive.js